import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import SERVICES from 'services';
import {CheckCircle} from 'phosphor-react';
import Loading from 'components/FullScreenLoading';

const Confirm = () => {
	const [success, setSuccess] = useState(true);
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();
	const location = useLocation() as any;

	const urlParams = new URLSearchParams(location.search);
	const token = urlParams.get('token');

	useEffect(() => {
		try {
			if (location?.state?.from === 'register') return;

			if (!token) throw new Error('Invalid token');

			setLoading(true);
			SERVICES.AUTH.confirmAccount(token)
				.then(() => {
					setTimeout(() => {
						navigate('/login');
					}, 5000);
					setSuccess(true);
				})
				.catch((e: {message: string | undefined}) => {
					setSuccess(false);
					throw new Error(e.message);
				})
				.finally(() => {
					setLoading(false);
				});
		} catch (e) {
			navigate('/register');
		}
	}, []);

	const ConfirmFromReg = () => (
		<>
			<div className="title">Էլ-փոստի Վավերացում</div>
			<div className="divider" />
			<div className="content">Ողջու՜յն: Հաստատման նամակն ուղարկվել է Ձեր էլեկտրոնային հասցեին </div>
		</>
	);

	const ErrorFromEmail = () => (
		<>
			<div className="logo">
				<CheckCircle weight="fill" size={52} color="#002494" />
			</div>
			<div className="title">Գրանցումն ավարտված է</div>
			<div className="divider" />
			<div className="content">
				Ձեր Էլեկտրոնային հասցեն հաջողությամբ վավերացված է: Շնորհակալությու՜ն։
			</div>
			<div className="footer">
				<a href="/login">Մուտք գործել համակարգ</a>
			</div>
		</>
	);

	const ConfirmFromEmail = () => (
		<>
			<div className="logo">
				<CheckCircle weight="fill" size={52} color="#002494" />
			</div>
			<div className="title">Գրանցումն ավարտված է</div>
			<div className="divider" />
			<div className="content">
				Ձեր Էլեկտրոնային հասցեն հաջողությամբ վավերացված է: Շնորհակալությու՜ն։
			</div>
			<div className="footer">
				<a href="/login">Մուտք գործել համակարգ</a>
			</div>
		</>
	);

	if (loading) return <Loading />;

	return (
		<div className="confirm">
			{location?.state?.from === 'register' ? (
				<ConfirmFromReg />
			) : success ? (
				<ConfirmFromEmail />
			) : (
				<ErrorFromEmail />
			)}
		</div>
	);
};

export default Confirm;
